<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #CuentasBancarias
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Cuentas Bancarias
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-btn.mb-2(v-if='cre' slot='activator', style="border-radius:5px;background-color:#d50d10;") Nueva Cuenta
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cuenta Bancaria
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8, sm8)
                          v-form

                            v-text-field(outline
                              v-model="form.banco"
                              prepend-inner-icon="account_balance"
                              label="Banco:")

                            v-text-field(outline
                              v-model="form.nroCuenta"
                              prepend-inner-icon="credit_card"
                              label="Número de cuenta:")

                            v-text-field(outline
                              v-model="form.rif"
                              prepend-inner-icon="fingerprint"
                              label="RIF:")

                            v-text-field(outline
                              v-model="form.telefono"
                              prepend-inner-icon="phone"
                              label="Teléfono:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:#d50d10;border-radius:10px;", @click.native='save') Guardar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs6)
              v-text-field(v-model='search', label='Buscar')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de Cuentas Bancarias
        v-data-table.elevation-1(:headers='headers', :items="resultados", :search='search', style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ props.item.banco }}
            td {{ props.item.nroCuenta }}
            td {{ props.item.rif }}
            td {{ props.item.telefono }}
            td
              v-icon(v-if='mod' small style='margin-right:10px;cursor:pointer;' @click='editItem(props.item)') edit
              v-icon(v-if='elm' small style='cursor:pointer;' @click='deleteItem(props.item)') delete
</template>

<script>
import Api from "@/services/methods";
export default {
  name: "CuentasBancarias",
  data: () => ({
    loading: false,
    search: "",
    dialog: false,
    editedIndex: -1,
    resultados: [],
    headers: [
      { text: "Banco", value: "banco" },
      { text: "Número de Cuenta", value: "nroCuenta" },
      { text: "RIF", value: "rif" },
      { text: "Teléfono", value: "telefono" },
      { text: "Acción" }
    ],
    form: {
      banco: "",
      nroCuenta: "",
      rif: "",
      telefono: ""
    },
    defaultForm: {
      banco: "",
      nroCuenta: "",
      rif: "",
      telefono: ""
    },
    cre: "",
    mod: "",
    elm: ""
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.adminemanuel.permisos.length; i++) {
        if (this.$store.state.adminemanuel.permisos[i].ruta === "Cuentas Bancarias") {
          for (let j = 0; j < this.$store.state.adminemanuel.permisos[i].accion.length; j++) {
            if (this.$store.state.adminemanuel.permisos[i].accion[j] === "Crear") this.cre = "yes";
            if (this.$store.state.adminemanuel.permisos[i].accion[j] === "Modificar") this.mod = "yes";
            if (this.$store.state.adminemanuel.permisos[i].accion[j] === "Eliminar") this.elm = "yes";
          }
        }
      }
    },
    initialize() {
      this.editedIndex = -1;
      Api.get("cuentasBancarias/all").then(res => {
        this.resultados = res.data;
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.editedIndex = -1;
      this.dialog = false;
      this.initialize();
    },
    editItem(item) {
      this.editedIndex = 1;
      this.form = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.$swal.fire({
        title: "¿Estás seguro?",
        text: "No podrás revertir esta operación!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, Eliminar!"
      }).then(result => {
        if (result.value) {
          Api.delete("cuentasBancarias/" + item._id).then(() => {
            this.$swal.fire("Felicidades.!", "Eliminación realizada exitosamente.", "success");
            this.initialize();
          }).catch(err => {
            console.log(err);
            this.$swal.fire("Oops...", "Error al eliminar.", "error");
          });
        }
      });
    },
    save() {
      if (!this.form.banco || !this.form.nroCuenta) {
        this.$swal.fire("¡Atención!", "Banco y número de cuenta son obligatorios.", "error");
        return;
      }
      this.loading = true;
      if (this.editedIndex === -1) {
        Api.post("cuentasBancarias", this.form).then(res => {
          if (res.data.success) {
            this.$swal.fire("Felicidades.!", "Registro creado exitosamente.", "success");
            this.close();
          } else {
            this.$swal.fire("¡Atención!", res.data.error, "error");
          }
          this.loading = false;
        }).catch(err => {
          console.log(err);
          this.loading = false;
          this.$swal.fire("Oops...", "Error encontrado, verifique los datos.", "error");
        });
      } else {
        Api.put("cuentasBancarias", this.form).then(res => {
          if (res.data.success) {
            this.$swal.fire("Felicidades.!", "Modificación realizada exitosamente.", "success");
            this.close();
          } else {
            this.$swal.fire("¡Atención!", res.data.error, "error");
          }
          this.loading = false;
        }).catch(err => {
          console.log(err);
          this.loading = false;
          this.$swal.fire("Oops...", "Error encontrado, verifique los datos.", "error");
        });
      }
    }
  }
};
</script>
<style lang="scss">
</style>
